import { useEffect, useState, useRef } from "react";
import { Button } from "devextreme-react/button";
import { useNavigate, useParams } from 'react-router-dom';
import apiUrl from '../../../configs/constant';
import axios from "axios";
import Swal from "sweetalert2";
import { Box, Grid, Typography } from "@mui/material";
import { set } from "react-hook-form";

interface WorkOrder {
  id: number;
  qty: number;
  satuan: string;
  proses: string;
  kode: string;
  product: string;
}
interface Proses {
  id: number;
  proses: string;
  qty: number;
  qty_hasil: number;
  satuan: string;
  tgl_awal: string | null;
  tgl_realisasi: string | null;
  tgl_selesai: string | null;
  urutan: number;
  is_input_persen: number;
}

const processes = ["Gudang", "Printing", "Potong", "Bordir", "Pembelian", "Penjahit", "QC", "BHP"];

export default function ProductionInput() {
  const navigate = useNavigate();

  return (
    <Grid container spacing={6} sx={{ alignItems: 'center', justifyContent: 'center' }}>
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
      >
        <h2 style={{ background: "#eee", textAlign: "center" }}>INPUT PRODUKSI</h2>
        <Grid container spacing={3} sx={{ alignItems: 'center', justifyContent: 'center' }}>
          {processes.map((item, index) => (
            <Grid item xs={6} sm={3} key={index}>
              <div style={{ cursor: 'pointer' }} onClick={() => navigate('/production/input-produksi/' + item)}>
                <Box
                  sx={{
                    p: 2,
                    border: '1px solid grey',
                    borderRadius: 0.8,
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Typography variant='h6'>{item}</Typography>
                </Box>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
